import React, {useState} from "react";
import IntegrationList from "../components/IntegrationList";
import IntegrationModal from "../components/IntegrationModal";
import Sidebar from "../components/Sidebar";

const IntegrationsManagement = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedIntegration, setSelectedIntegration] = useState(null);
    const handleSave = () => {
        console.log("Closing modal...");
        setShowModal(false);
        setSelectedIntegration(null);
    };

    const handleEdit = (integration) => {
        console.log("Editing Integration:", integration);
        setSelectedIntegration(integration);
        setShowModal(true);
    };

    return (

        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <div>
                    <header className="header component">
                        <span className="component-header">Integrations</span>
                        <button
                            className="btn btn-primary action"
                            onClick={() => {
                                setSelectedIntegration(null);
                                setShowModal(true);
                            }}
                        >
                            <i className="fa fa-plus"></i> Add Integration
                        </button>
                    </header>
                    <hr/>


                    <IntegrationList onEdit={handleEdit}/>
                    {showModal && (
                        <IntegrationModal
                            integration={selectedIntegration}
                            onClose={() => setShowModal(false)}
                            onSave={handleSave}
                        />
                    )}
                </div>
            </main>

        </div>


    )
        ;
};

export default IntegrationsManagement;